import React, {useEffect, useRef} from "react";
import Button from "../baseComponents/gui/button/Button";
import {navButtons} from "../../constants/copyright";
import {safeHTML} from "../../utils/safeHTML";
import NewsHeader from "./NewsHeader";
import {usePanel} from "../../redux/reducer/panel";
import Recommendations from "../recommendations/Recommendations";
import AppearSensor from "../baseComponents/helpers/appearSensor/AppearSensor";
import classNames from "classnames";
import Games from "../games/Games";
import ReadNow from "../readNow/ReadNow";
import CurrentCirculations from "../currentCirculations/CurrentCirculations";
import useCustomCopy from "../../utils/useCustomCopy";
import {useRouter} from "next/router";
import styles from "./News.module.scss";
import Image from "next/image";

const News = React.forwardRef(
  function News(props, ref) {
    const {
      title, tags, preview,
      preview_mobile,
      text, id, name,
      author,authors, details, content,
      comments, headings,
      recommendation,
      bets,superBets,readings
    } = props;

    const {buttonBack, buttonToTop} = navButtons;
    const {filter} = usePanel();
    const bodyRef = useRef()
    const readRef = useRef()

    useCustomCopy()

    useEffect(()=>{
      if(!bodyRef.current || !readRef.current) return
      const node = bodyRef.current?.querySelector('#сurrently-reading')
      if(!node) return;
      readRef.current.style.display = 'block'
      node.insertAdjacentElement('afterend',readRef.current)
    },[])

    useEffect(() => {
      const title = bodyRef.current?.querySelector('[data-author-id]');
      const authorId = title?.dataset.authorId;


      if(!authors) return

      if (title && authorId) {
        const currentAuthor = authors.find(({id}) => id === +authorId);
        console.log(currentAuthor,'AITHOR')
        title.addEventListener('click',()=>console.log('title'))

        if (currentAuthor?.photo) {
          // Создаем элемент изображения
          const imgElement = document.createElement('img');
          imgElement.src = currentAuthor.photo;
          imgElement.alt = `Автор ${currentAuthor.name}`;

          // Создаем контейнер для изображения
          const container = document.createElement('div');
          container.style.display = 'flex';
          container.style.alignItems = 'center';
          container.appendChild(imgElement);

          // Добавляем оригинальный контент title в контейнер
          container.appendChild(title.cloneNode(true));

          // Заменяем оригинальный title на наш контейнер
          title.parentNode.replaceChild(container, title);
        }
      }
    }, [authors]);
    // const likes = useMemo(() => details.tags.filter(({type}) => type === 'likes')?.[0], [details]);

    return (
      <section className={styles.news} ref={ref}>
        <div className={styles.news__content}>
          <Button routerUrl={filter ? filter : '/'} {...buttonBack}/>
          <NewsHeader {...{title, tags, author}}/>
          <div className={styles.news__preview}>
            <picture>
              <source media="(max-width: 1023px)" srcSet={preview_mobile || preview} />
              <Image
                src={preview}
                alt="Превью"
                width={1312}
                height={600}
                quality={100}
                loading="eager"
                sizes="(max-width: 1023px) 100vw, 1600px"
                priority
              />
            </picture>
          </div>


              <div className={styles.news__main}>
                {!!superBets?.length && <CurrentCirculations list={superBets}/>}
                {/*<h2 className={"news__subtitle"}>{safeHTML(name)}</h2>*/}
                <div ref={bodyRef} className={styles.news__body}>
                  {safeHTML(text)}
                </div>
                {/*  <Tag {...likes} mod={'main'}/>*/}
                {/*{author && <NewsAuthorBlock {...author}/>}*/}
                {readings.length > 0 && <ReadNow ref={readRef} list={readings}/>}
                {!!bets.length && <Games bets={bets}/>}
              </div>


          {/*/!*<OriginalPosts list={newsList} mod={'news'}/>*!/*/}
          {/*-<AppearSensor partialVisibility={true}>*/}
          {/*  {({hasBeenVisible}) =>*/}
          {/*    <Comments comments={comments} className={classNames("", {*/}
          {/*      "comments_show": hasBeenVisible*/}
          {/*    })}/>*/}
          {/*  }*/}
          {/*</AppearSensor>*/}
          <Recommendations title={"Последние новости"} list={recommendation} mod={"news"} showAnimation={true}/>
          <Button {...buttonToTop} onClick={() => scrollTo({top: 0, behavior: "smooth"})}
          />
        </div>
      </section>
    );
  });
export default News;
News.propTypes = {};

